import { Selector } from '@ngxs/store';

import { enumBillItemProductCode } from '@data-layer/enums/payments';
import { HintModel, ProductDetailsModel, ShortModel } from '@app/data-layer/models/common';
import { ManagementBrokerModel } from '@app/data-layer/models/management/brokers';
import { ManagementLdsConnectionModel, ManagementQuoteModel } from '@app/data-layer/models/management';
import { ProductManagementModel } from '@app/data-layer/models/management/products';
import { SharedStateModel } from './shared-state.model';
import { SharedState } from './shared.state';
import { ManagementBillItemModel } from '@data-layer/models/management/bill-items';
import { UserBetaFlagModel } from '@data-layer/models/user';

export class SharedSelectors {
  @Selector([SharedState])
  public static getAllBrokers(state: SharedStateModel): ManagementBrokerModel[] {
    return state.brokers;
  }

  @Selector([SharedState])
  public static getAllAffiliates(state: SharedStateModel): ShortModel[] {
    return state.affiliates;
  }

  @Selector([SharedState])
  public static getAllLdsConnections(state: SharedStateModel): ManagementLdsConnectionModel[] {
    return state.ldsConnections;
  }

  @Selector([SharedState])
  public static getDefaultProducts(state: SharedStateModel): ProductManagementModel[] {
    return state.defaultProducts;
  }

  @Selector([SharedState])
  public static getAllQuotes(state: SharedStateModel): ManagementQuoteModel[] {
    return state.quotes;
  }

  @Selector([SharedState])
  public static getAllBillItems(state: SharedStateModel): ManagementBillItemModel[] {
    return state.billItems;
  }

  @Selector([SharedState])
  public static getAllHints(state: SharedStateModel): HintModel[] {
    return state.hints;
  }

  @Selector([SharedState])
  public static getAppBetaFlags(state: SharedStateModel): UserBetaFlagModel[] {
    return state.appBetaFlags || [];
  }

  @Selector([SharedState])
  public static getProductsByCompany(state: SharedStateModel): ProductDetailsModel[] {
    return state.productsByCompany;
  }

  // #13213 — POA price is displayed from the backend product config; the entry carries the
  // companyId it was fetched for, so consumers must match it against their own company
  @Selector([SharedState])
  public static getPoaProductDetails(state: SharedStateModel): ProductDetailsModel | null {
    return state.productsByCompany.find((item: ProductDetailsModel) => item.productCode === enumBillItemProductCode.POA) ?? null;
  }

  // #13318 — the price for a company that does not exist yet (create-company page); it is kept
  // out of productsByCompany so it cannot evict the price fetched for a real company
  @Selector([SharedState])
  public static getPoaProductDetailsByOrganization(state: SharedStateModel): ProductDetailsModel | null {
    return state.productsByOrganization.find((item: ProductDetailsModel) => item.productCode === enumBillItemProductCode.POA) ?? null;
  }

  @Selector([SharedState])
  public static getAllProductCategories(state: SharedStateModel): ShortModel[] {
    return state.productCategories;
  }
}
